import * as React from "react";
import "react-toastify/dist/ReactToastify.css";
import { BrowserTemplate } from "../base-template";
import { ContentsContainer } from "@graffer-inc/console-design-kit";
import { emptyFunction } from "../../../utils/function-utils";
import { Header } from "../../organisms/common/header";
import "./default-template.scss";
import { HelpErrorBoundary } from "./help-error-boundary";

const TITLE = "ヘルプ";

export const HelpTemplate: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  return (
    <div id="rootWrapper" className="help-template">
      <BrowserTemplate title={TITLE}>
        <Header title={TITLE} onLogoClick={emptyFunction} />
        <HelpErrorBoundary>
          <ContentsContainer>{children}</ContentsContainer>
        </HelpErrorBoundary>
        <footer>
          Copyright © Graffer, Inc. All Rights Reserved. Confidential - Not to
          be disclosed or distributed to third parties.
        </footer>
      </BrowserTemplate>
    </div>
  );
};
